
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SuperAdminAuthProvider } from "@/contexts/SuperAdminAuthContext";
import { ShopAuthProvider } from "@/contexts/ShopAuthContext";
import { AuthProvider } from "@/hooks/useAuth";
import Index from "./pages/Index";
import OilFinder from "./pages/OilFinder";
import FilterFinder from "./pages/FilterFinder";
import OilRequest from "./pages/OilRequest";
import Shops from "./pages/Shops";
import About from "./pages/About";
import Contact from "./pages/Contact";
import UnifiedLogin from "./pages/UnifiedLogin";
import Signup from "./pages/Signup";
import Terms from "./pages/Terms";
import OilRequestAdmin from "./pages/OilRequestAdmin";
import SuperAdminLogin from "./pages/SuperAdminLogin";
import SuperAdmin from "./pages/SuperAdmin";
import Booking from "./pages/Booking";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <ShopAuthProvider>
          <SuperAdminAuthProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/oil-finder" element={<OilFinder />} />
                <Route path="/filter-finder" element={<FilterFinder />} />
                <Route path="/oil-request" element={<OilRequest />} />
                <Route path="/shops" element={<Shops />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/login" element={<UnifiedLogin />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/oil-request-admin" element={<OilRequestAdmin />} />
                <Route path="/super-admin-login" element={<SuperAdminLogin />} />
                <Route path="/super-admin" element={<SuperAdmin />} />
                <Route path="/booking" element={<Booking />} />
              </Routes>
            </BrowserRouter>
          </SuperAdminAuthProvider>
        </ShopAuthProvider>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
